import PlatformActions from './PlatformActions'

export default class PPSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      gameType: 'SLOT',
      gameCode: 'PP-SLOT-082',
      platform: 'PP',
    }

    this.gameName = 'Sweet Bonanza'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: txnId, // 61764eaa91c65d06c01968cd
      roundId: `${roundId}`, // 10755280720215
      betType: null,
      currency,
      betTime, // 2021-10-01T13:11:15.798+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        isBuyFreeSpin: false,
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `${roundId}`, // 10755280720215
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2021-10-01T13:11:16.017+08:00
      roundId: `${roundId}`,
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betInfos: [{
          isBuyFreeSpin: false,
        }],
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      txnId,
      roundId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: txnId,
      roundId: `${roundId}`,
      gameInfo: {
        isBuyFreeSpin: false,
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }

  getBetNSettleMessage(txnList) {
    const { currency } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotWinAmount,
      updateTime,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `${roundId}`, // 10755280720215
      roundId: `${roundId}`,
      betType: null,
      currency,
      betTime, // 2021-11-27T08:56:09.000+08:00
      txTime: betTime,
      betAmount,
      turnover,
      winAmount,
      jackpotBetAmount: 0,
      jackpotWinAmount: jackpotWinAmount ?? 0,
      updateTime, // 2021-10-01T13:11:16.017+08:00
      requireAmount: betAmount,
      gameInfo: {
        betInfos: [{
          isBuyFreeSpin: false,
        }],
      },
    }))

    const message = {
      action: 'betNSettle',
      txns,
    }

    return JSON.stringify(message)
  }

  getGiveMessage(txnList) {
    const { currency } = this.formData

    const txns = txnList.map(({
      userId,
      betAmount,
      promotionTxId,
      txTime,
    }) => ({
      platform: this.constantTxnData.platform,
      currency,
      userId,
      amount: betAmount,
      promotionTxId: `${promotionTxId}`, // 663316e474062c4224d1c2b5
      promotionId: '1026',
      promotionTypeId: '8',
      txTime, // 2024-05-02T12:30:28.592+08:00
    }))

    const message = {
      action: 'give',
      txns,
    }

    return JSON.stringify(message)
  }
}
